(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/coupon/mini-meta.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/coupon/mini-meta.js');

'use strict';

const Icon = svs.ui.ReactIcon;
const MiniMetaColumn = svs.racing_game.components.play.MiniMetaColumn;
const {
  useState,
  useEffect,
  useMemo
} = React;
const isMobile = svs.core.detect.formfactor.mobile();
const isDesktop = svs.core.detect.formfactor.desktop();
const MIN_EXPANDBTN_TOP = 25;
const MAX_EXPANDBTN_TOP = 50;
const FADE_LEFT_SELECTOR = '.mini-meta-left-arrow';
const FADE_RIGHT_SELECTOR = '.mini-meta-right-arrow';
let columnInfo;
const MiniMeta = _ref => {
  let {
    meta = [],
    participants = [],
    isExpanded,
    setIsExpanded,
    itemClass,
    gait,
    gameType,
    isResult
  } = _ref;
  const [btnHolderTop, setBtnHolderTop] = useState(60);
  const additionalDistanceMap = useMemo(() => participants.map(participant => ({
    participantId: participant.participantId,
    additionalDistance: participant.additionalDistance
  })), [participants]);
  const getColumnInfo = () => {
    const metaCols = document.getElementsByClassName('mini-meta-column');
    const cols = [];
    const odds = {};
    let index = 0;
    for (let i = 0; i < metaCols.length; i++) {
      if (metaCols[i].className.includes('mini-meta-odds-latest')) {
        odds.width = metaCols[i].clientWidth;
        odds.offset = metaCols[i].offsetLeft;
      } else if (metaCols[i].className.includes('mini-meta-odds-ref')) {
        cols.push({
          index: index++,
          width: metaCols[i].clientWidth + odds.width,
          class: metaCols[i].className.replace('mini-meta-column ', ''),
          offsetLeft: odds.offset,
          current: i === 0 ? 'current' : ''
        });
      } else {
        cols.push({
          index: index++,
          width: metaCols[i].clientWidth,
          class: metaCols[i].className.replace('mini-meta-column ', ''),
          offsetLeft: metaCols[i].offsetLeft,
          current: i === 0 ? 'current' : ''
        });
      }
    }
    return cols;
  };
  const buttonClickHandler = () => {
    setIsExpanded(!isExpanded);
    document.querySelector('.mini-meta-content').scrollTo({
      behavior: 'smooth',
      left: 0
    });
  };
  const getMetaColumnOffset = direction => {
    if (!columnInfo) {
      columnInfo = getColumnInfo();
    }
    const currentColumn = columnInfo.find(_ref2 => {
      let {
        current
      } = _ref2;
      return current === 'current';
    });
    if (direction === 'next' && currentColumn.index !== columnInfo.length - 1) {
      const nextColumn = columnInfo.find(col => col.index === currentColumn.index + 1);
      columnInfo[currentColumn.index].current = '';
      columnInfo[nextColumn.index].current = 'current';
      return nextColumn.offsetLeft;
    } else if (direction === 'prev' && currentColumn.index !== 0) {
      const prevColumn = columnInfo.find(col => col.index === currentColumn.index - 1);
      columnInfo[currentColumn.index].current = '';
      columnInfo[prevColumn.index].current = 'current';
      return prevColumn.offsetLeft;
    } else if (currentColumn.index < columnInfo.length) {
      const diff = currentColumn.width - document.querySelector('.mini-meta').clientWidth;
      return currentColumn.offsetLeft + diff - 1;
    }
  };
  const handleRightArrowClick = () => {
    const metaContent = document.querySelector('.mini-meta-content');
    const scrollOffset = getMetaColumnOffset('next');
    metaContent.scrollTo({
      behavior: 'smooth',
      left: scrollOffset
    });
  };
  const handleLeftArrowClick = () => {
    const metaContent = document.querySelector('.mini-meta-content');
    const scrollOffset = getMetaColumnOffset('prev');
    metaContent.scrollTo({
      behavior: 'smooth',
      left: scrollOffset
    });
  };

  const handleScroll = e => {
    window.requestAnimationFrame(() => {
      var _document$querySelect, _document$querySelect2;
      const windowOffset = isMobile ? window.pageYOffset : document.querySelector('#left-column').scrollTop;
      const buttonScrollheight = isMobile ? (_document$querySelect = document.querySelector('.mini-meta')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.scrollHeight : e.target.scrollTop;
      const miniMetaHeight = (_document$querySelect2 = document.querySelector('.mini-meta')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.clientHeight;
      const holderHeight = isDesktop ? Math.round((windowOffset - miniMetaHeight / buttonScrollheight) / 1.35) : Math.round((windowOffset - miniMetaHeight / buttonScrollheight) / 1.5 - 50);
      if (holderHeight > MIN_EXPANDBTN_TOP && holderHeight < miniMetaHeight - MAX_EXPANDBTN_TOP) {
        setBtnHolderTop(holderHeight);
      }
    });
  };
  const handleArrowScrolls = () => {
    const isMiniMeta = document.querySelector('.mini-meta');
    const fadeLeftEl = isMiniMeta && document.querySelector(FADE_LEFT_SELECTOR);
    const fadeRightEl = isMiniMeta && document.querySelector(FADE_RIGHT_SELECTOR);
    const miniMetaColWidth = isMiniMeta && document.querySelector('.mini-meta').clientWidth;
    const scrollWidth = isMiniMeta && document.querySelector('.mini-meta-content').scrollWidth;
    const scrollLeft = isMiniMeta && document.querySelector('.mini-meta-content').scrollLeft;
    const scrollLength = scrollWidth - miniMetaColWidth;
    if (!fadeLeftEl || !fadeRightEl) {
      return;
    }
    if (fadeLeftEl && fadeRightEl) {
      if (miniMetaColWidth >= scrollWidth) {
        fadeRightEl.classList.add('hidden');
        fadeLeftEl.classList.add('hidden');
      } else if (scrollLeft === 0) {
        fadeLeftEl.classList.add('hidden');
        fadeRightEl.classList.remove('hidden');
      } else if (scrollLeft >= scrollLength - 5) {
        fadeRightEl.classList.add('hidden');
        fadeLeftEl.classList.remove('hidden');
      } else if (scrollLeft > 0) {
        fadeLeftEl.classList.remove('hidden');
        fadeRightEl.classList.remove('hidden');
      } else {
        fadeRightEl.classList.add('hidden');
        fadeLeftEl.classList.add('hidden');
      }
    }
  };
  useEffect(() => {
    if (isDesktop) {
      let resizeTimer;
      document.querySelector('.mini-meta-content').addEventListener('scroll', handleArrowScrolls);
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          handleArrowScrolls();
        }, 250);
      });
      handleArrowScrolls();
      columnInfo = undefined;
    }
    return () => {
      if (isDesktop) {
        var _document$querySelect3;
        (_document$querySelect3 = document.querySelector('.mini-meta-content')) === null || _document$querySelect3 === void 0 || _document$querySelect3.removeEventListener('scroll', handleArrowScrolls);
        window.removeEventListener('resize', handleArrowScrolls);
      }
    };
  }, []);
  useEffect(() => {
    if (isMobile) {
      window.addEventListener('scroll', handleScroll);
    } else {
      document.querySelector('#left-column').addEventListener('scroll', handleScroll);
    }
    return () => {
      if (isMobile) {
        window.removeEventListener('scroll', handleScroll);
      } else {
        document.querySelector('#left-column').removeEventListener('scroll', handleScroll);
      }
    };
  }, []);
  return React.createElement("div", {
    className: "mini-meta".concat(isExpanded ? ' mini-meta-expanded' : '')
  }, meta && meta.length > 0 && React.createElement(React.Fragment, null, isDesktop && React.createElement("div", {
    className: "mini-meta-arrow-container",
    style: {
      transform: "translate3d(0, ".concat(btnHolderTop, "px, 0)")
    }
  }, React.createElement("div", {
    className: "mini-meta-left-arrow",
    onClick: handleLeftArrowClick
  }, React.createElement("div", {
    className: "mini-meta-racing-swipe-arrow"
  }, React.createElement(Icon, {
    color: "fc-black",
    icon: "badge-arrow-left",
    size: "600"
  }))), React.createElement("div", {
    className: "mini-meta-right-arrow",
    onClick: handleRightArrowClick
  }, React.createElement("div", {
    className: "mini-meta-racing-swipe-arrow"
  }, React.createElement(Icon, {
    color: "fc-black",
    icon: "badge-arrow-right",
    size: "600"
  })))), isMobile && svs.core.detect.breakpoint.lessThan('md') && React.createElement("button", {
    className: "mini-meta-toggle-btn",
    onClick: () => buttonClickHandler(),
    type: "button"
  }, isExpanded ? React.createElement(Icon, {
    icon: "menu-right",
    size: "100"
  }) : React.createElement(Icon, {
    icon: "menu-left",
    size: "100"
  }))), React.createElement("div", {
    className: "mini-meta-content"
  }, meta && meta.map(metaColumn => React.createElement(MiniMetaColumn, {
    additionalDistanceMap: additionalDistanceMap,
    expandMiniMeta: () => isMobile && buttonClickHandler(),
    gait: gait,
    gameType: gameType,
    getHeaderByGameType: metaColumn.getHeaderByGameType,
    hasExplanation: metaColumn.hasExplanation,
    header: metaColumn.header,
    isExpanded: isExpanded,
    isResult: isResult,
    itemClass: itemClass,
    key: metaColumn.header,
    rows: metaColumn.data,
    subHeader: metaColumn.subHeader,
    type: metaColumn.type
  }))));
};
svs.racing_game.components.play.MiniMeta = MiniMeta;

 })(window);